import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { AuthGuardService } from './modules/auth/guards/auth-guard.service';

export const appRoutes: Routes = [
    {
        path: '',
        component: PublicLayoutComponent,
        canActivate: [],
        children: [
            {
                path: '',
                loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
            }
        ]
    },
    {
        path: 'login',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'admin'
    }
];
